<template>
<v-app class="ma-0 pa-0">
    <div id="app">
      <img-header/>
        <v-row class="hero_section">
            <div class="absolute">
            <div class="hero_content">{{ $t("hero.title") }} </div>
            <div class="centered">
            <v-dialog
            v-if="lang=='en'"
            v-model="dialog"
            persistent
            max-width="700px">
            <template v-slot:activator="{ on, attrs }">
                <div class="blue_button"  v-bind="attrs" v-on="on">
                    <p class="blue_button_content" >{{ $t("hero.upload") }} </p>
                </div>
            </template>
            <v-card class="pa-4">
                <v-row class="d-flex justify-end pa-3">
                    <v-btn icon 
                    color="error"
                    large
                    @click="closeDialog"><v-icon>mdi-close</v-icon>
                </v-btn>
                </v-row>
                <v-form v-on:submit.prevent="submit">
                <v-card-title align="center">
                <span v-if="!uploadSucess && !whileUploading" class="text-h5 ">{{ $t("form.title1") }}</span>
                <span v-if="whileUploading && hospitalName" class="text-h5 ">{{ $t("form.title2") }} {{hospitalName}} {{ $t("form.title22") }}</span>
                <span v-if="uploadSucess" class="text-h5"> {{ $t("form.title3") }}</span>
                </v-card-title>
                <v-card-text>
                    <v-row v-if="!uploadSucess && !whileUploading">
                    <v-col cols="12">
                    <v-file-input
                        type="file"
                        multiple
                        webkitdirectory directory
                        v-model="dropboxForm.files"
                        counter
                        ref="file"
                    ></v-file-input>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                        value="Select"
                        v-model="dropboxForm.password"
                        label="Please enter the last 4 digits of your ID card*"
                        type="password"
                        counter="4"
                        required
                        :rules="rules"
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                    <v-dialog
                    v-model="hospitalDialog"
                    persistent
                    max-width="720px">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <v-text-field
                            v-model="hospitalLocName"
                            label="Please select the hospital you want to send"
                            ></v-text-field>
                        </div>
                    </template>
                    <v-card class="pa-4">
                        <v-card-title align="center">
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                            <v-col cols="12">
                            <v-combobox
                                v-model="hospitalLocation"
                                :items="hospitalLocations"
                                label="Location"
                                dense
                                @input="onLocationClicked"
                            ></v-combobox>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox
                                v-model="hospitalName"
                                :items="hospitalNames"
                                label="Transmission Cooperative Hospital"
                                dense
                                @input="addCustomerNumber"
                                ></v-combobox>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text large
                            @click="cancelHos">
                            <span class="text-h5 ">{{ $t("form.cancel") }}</span>
                        </v-btn>
                        <v-btn
                            color="blue"
                            text large
                            @click="saveHos"
                            >
                            <span class="text-h5 ">{{ $t("form.save") }}</span>
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-dialog>
                    </v-col> -->
                    </v-row>
                    <div v-if="whileUploading" class="whileUpload">
                    <v-progress-linear v-model="progress" style="margin-top:14px; margin-bottom:24px;"></v-progress-linear> 
                    <p v-if="!compressing" style="font-size:20px;">{{ $t("form.fileupload") }} {{this.progress}}{{ $t("form.complete") }}</p>
                    <p v-else style="font-size:20px;" >{{ $t("form.compress") }}</p>
                    </div>
                    <qrcode v-show="qrCodeUrl" v-model="qrCodeUrl" ></qrcode>
                    <p v-show="uploadName" style="font-size:20px;">
                        Name: {{uploadName}}
                    </p>
                    <p v-show="uploadAge" style="font-size:20px;">
                        Age: {{uploadAge}}
                    </p>
                    <p v-show="uploadSex" style="font-size:20px;">
                        Sex: {{uploadSex}}
                    </p>
                    <p v-if="hospitalDataSending" style="font-size:20px;" >{{ $t("form.image") }}</p>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="!uploadSucess && !whileUploading"
                    v-show="this.dropboxForm.files!='' &&
                    this.dropboxForm.password.length==4"
                    color="blue"
                    text large
                    @click="submit"
                    >
                    <span class="text-h5 ">{{ $t("form.upload") }}</span>
                </v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
            </v-dialog>
            <v-dialog
            v-else
            v-model="dialog"
            persistent
            max-width="720px">
            <template v-slot:activator="{ on, attrs }">
                <div class="blue_button"  v-bind="attrs" v-on="on">
                <p class="blue_button_content" >{{ $t("hero.upload") }} </p>
            </div>
            </template>
            <v-card class="pa-4">
                <v-row class="d-flex justify-end pa-3">
                    <v-btn icon 
                    color="error"
                    large
                    @click="closeDialog"><v-icon>mdi-close</v-icon>
                </v-btn>
                </v-row>
                <v-form v-on:submit.prevent="submit">
                <v-card-title align="center">
                <span v-if="!uploadSucess && !whileUploading" class="text-h5 ">請選取含有影像檔之目錄</span>
                <span v-if="whileUploading && hospitalName" class="text-h5 ">影像將傳送至{{nameEnglish}}醫院，請稍後… 需同時向該院所申請外院片光碟影像轉入，影像方能送達該醫院系統中</span>
                <span v-if="uploadSucess" class="text-h5"> 請開啟手機中之FHR APP，掃描QR code，將影像檔載入手機</span>
                </v-card-title>
                <v-card-text>
                    <v-row v-if="!uploadSucess && !whileUploading">
                    <v-col cols="12">
                    <v-file-input
                        type="file"
                        multiple
                        webkitdirectory
                        v-model="dropboxForm.files"
                        counter
                        ref="file"
                    ></v-file-input>
                    
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                        value="Select"
                        v-model="dropboxForm.password"
                        label="請輸入身分證末4碼*"
                        type="password"
                        counter="4"
                        required
                        :rules="rules"
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                    <v-dialog
                    v-model="hospitalDialog"
                    persistent
                    max-width="720px">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <v-text-field
                            v-model="hospitalLocName"
                            label="請選擇欲傳送醫院"
                            ></v-text-field>
                        </div>
                    </template>
                    <v-card class="pa-4">
                        <v-card-title align="center">
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                            <v-col cols="12">
                            <v-combobox
                                v-model="hospitalLocation"
                                :items="hospitalLocations"
                                label="地區"
                                dense
                                @input="onLocationClicked"
                            ></v-combobox>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox
                                v-model="hospitalName"
                                :items="hospitalNames"
                                label="傳送合作醫院"
                                dense
                                @input="addCustomerNumber"
                                ></v-combobox>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text large
                            @click="cancelHos">
                            <span class="text-h5 ">取消</span>
                        </v-btn>
                        <v-btn
                            color="blue"
                            text large
                            @click="saveHos"
                            >
                            <span class="text-h5 ">確定</span>
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-dialog>
                    </v-col> -->
                    </v-row>
                    <div v-if="whileUploading" class="whileUpload">
                    <v-progress-linear v-model="progress" style="margin-top:14px; margin-bottom:24px;"></v-progress-linear> 
                    <p v-if="!compressing" style="font-size:20px;">檔案上傳中… {{this.progress}}%完成</p>
                    <p v-else style="font-size:20px;" >檔案壓縮中，請稍後…</p>
                    </div>
                    <qrcode v-show="qrCodeUrl" v-model="qrCodeUrl" ></qrcode>
                    <p v-show="uploadName" style="font-size:20px;" >
                        姓名: {{uploadName}}
                    </p>
                    <p v-show="uploadAge" style="font-size:20px;" >
                        年齡: {{uploadAge}}
                    </p>
                    <p v-show="uploadSex" style="font-size:20px;" >
                        性別: {{uploadSex}}
                    </p>
                    <p v-if="hospitalDataSending" style="font-size:20px;" >影像傳送醫院中</p>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="!uploadSucess && !whileUploading"
                    v-show="this.dropboxForm.files!='' &&
                    this.dropboxForm.password.length==4"
                    color="blue"
                    text large
                    @click="submit"
                    >
                    <span class="text-h5 ">上傳</span>
                </v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
            </v-dialog>
            <div class="blue_button2" @click="$vuetify.goTo('#scrollhere')">
                <p class="blue_button_content2" >{{ $t("hero.learn") }}</p>
            </div>
            </div>
            </div>
            <img src="@/assets/fhrvue/home.png" class="hero_img1 ">
        </v-row>
        <v-row class="h-673 w-390 mb-4 mb-md-12" id="scrollhere" >
            <v-col cols=12 md="6"  data-aos="fade-right" data-aos-duration="1500"  >
                <div class="w-390">
                <p class="h_title">{{ $t("how.title") }}</p>
                <p class="s_title mt-24">{{ $t("how.subtitle") }}</p>
                <ul class=" s_title mt-24">
                    <li>{{ $t("how.point1") }} </li>
                    <li>{{ $t("how.point2") }}</li>
                </ul>
                </div>
            </v-col>
            <v-col cols="12" md="6" data-aos="fade-left" data-aos-duration="1500">
                <v-row>
                <img src="@/assets/fhrvue/connect.png" class="h_img mt-132">
                </v-row>
                <v-row>
                <img src="@/assets/fhrvue/files.png" class="h_img">
                </v-row>
            </v-col>
        </v-row>
        <div class="m_div">
            <p data-aos="fade-up" data-aos-duration="1500" class="pt-159 blu m_font">{{ $t("help.title") }} <span>{{ $t("help.title2") }} </span> {{ $t("help.title3") }} </p>
            <v-row class="mt-49">
            <v-col cols="12" md="4">
                <div class="courier_step float-r">
                <img src="@/assets/fhrvue/acc1.png" class="how_img">
                <p class="how_text">{{ $t("help.subtitle1") }} </p>
                <p class="how_text2"> {{ $t("help.point1") }} </p>
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <div class="courier_step">
                <img src="@/assets/fhrvue/acc2.png" class="how_img">
                <div class="ml-50">
                <p class="how_text">{{ $t("help.subtitle2") }} </p>
                <p class="how_text2">{{ $t("help.point2") }}</p>
                </div>
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <div class="courier_step float-l">
                <img src="@/assets/fhrvue/acc3.png" class="how_img">
                <p class="how_text">{{ $t("help.subtitle3") }}</p>
                <p class="how_text2">{{ $t("help.point3") }}</p>
                </div>
            </v-col>
        </v-row>
        </div>
        <div class="h-1595">
            <p data-aos="fade-up" data-aos-duration="1500" class="f_title">{{ $t("steps.title1") }}<span>{{ $t("steps.title2") }}</span> {{ $t("steps.title3") }}</p>
            <v-container class="mx-235">
                <div class="row">
                    <div >
                        <div class="vl">
                            <img src="@/assets/fhrvue/cdman.png" class="s_img s_img_edit">
                            <div class="inline"> 
                            <div class="circle">
                                <p>1</p>
                            </div>
                            <p class="f_step">{{ $t("steps.subtitle1") }}</p>
                            </div>
                            <div >
                                <p class="f_content">{{ $t("steps.point1") }}</p>
                                <p class="f_content mt-56 mb-77">{{ $t("steps.point2") }}</p>
                            </div>

                        <div class="circle">
                            <p>2</p>
                        </div>
                        <p class="f_step">{{ $t("steps.subtitle2") }}</p>
                        <p class="f_content">{{ $t("steps.point3") }}</p>
                        <div class="upload_div" @click="dialog=true"><div class="cursor">{{ $t("steps.upload") }}</div></div>
                        <img src="@/assets/fhrvue/animation.gif" class="anime s_img_edit2">
                        <div class="circle">
                            <p>3</p>
                        </div>
                        <p class="f_step">{{ $t("steps.subtitle3") }}</p>
                        <p class="f_content mb-182">{{ $t("steps.point4") }}</p>
                        <div class="d_app d_app_edit">
                            <p class="d_content"><span>{{ $t("steps.first1") }} </span> {{ $t("steps.first2") }}</p>
                                 <img src="@/assets/fhr_qr.png" class="d_icon">
                            <p class="d_con"> {{ $t("steps.download") }}</p>
                        </div>
                        <div class="mt-20">
                        <div class="circle">
                            <p>4</p>
                        </div>
                        <p class="f_step">{{ $t("steps.subtitle4") }}</p>
                        <p class="f_content">{{ $t("steps.point5") }}</p>
                            <div>
                                <img v-if="lang=='en'" src="@/assets/fhrvue/phone_eg.png" class="f_img">
                                <img v-else src="@/assets/fhrvue/phone_ch.png" class="f_img">
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </v-container>
            <div class="phone">
                <img src="@/assets/fhrvue/cdman.png" class="s_img">
                <div class="circle">
                    <p>1</p>
                </div>
                <p class="f_step">{{ $t("steps.subtitle1") }}</p>
                <p class="f_content">{{ $t("steps.point1") }}</p>
                    <p class="f_content mt-56 mb-77">{{ $t("steps.point2") }}</p>
                
                <div class="circle">
                    <p>2</p>
                </div>
                <p class="f_step">{{ $t("steps.subtitle2") }}</p>
                <p class="f_content">{{ $t("steps.point3") }}</p>
                <div class="upload_div" @click="dialog=true">{{ $t("steps.upload") }}</div>
                <p class="f_content">{{ $t("steps.point6") }}</p>
                <img src="@/assets/fhrvue/animation.gif" class="anime">
                <div class="circle">
                    <p>3</p>
                </div>
                <p class="f_step">{{ $t("steps.subtitle3") }}</p>
                <p class="f_content">{{ $t("steps.point4") }}</p>
                <div>
                    <img v-if="lang=='en'" src="@/assets/fhrvue/phone_eg.png" class="f_img">
                    <img v-else src="@/assets/fhrvue/phone_ch.png" class="f_img">
                </div>
                <div class="circle">
                    <p>4</p>
                </div>
                <p class="f_step">{{ $t("steps.subtitle4") }}</p>
                <p class="f_content mb-56">{{ $t("steps.point5") }}</p>
                <div class="d_app">
                    <p class="d_content"><span>{{ $t("steps.first1") }}</span> {{ $t("steps.first2") }}</p>
                            <img src="@/assets/fhr_qr.png" class="d_icon">
                    <p class="d_con"> {{ $t("steps.download") }}</p>
                </div>

            </div>
        </div>
        <img-contact-form/>
        <img-footer/>
    </div>
</v-app>
</template>
<script>
import axios from 'axios'
import ImgContactForm from './ImgContactForm.vue'
import ImgHeader from './ImgHeader.vue'
import ImgFooter from './ImgFooter.vue'
export default {
    data:function(){
        const lang = localStorage.getItem('lang')
        return{
            lang:lang,
            hospitalNames:[],
            dialog:false,
            e6:1,
            hospitalLocName:'',
            hospitalLocations:[],
            hospitalRes:[],
            compressing:false,
            uploadSucess:false,
            whileUploading:false,
            rules: [v => v.length <= 4 || '4 digit passcode'],
            progress:0,
            qrCodeUrl: "",
            uploadAge:'',
            uploadName:'',
            uploadSex:'',
            tempFile:null,
            dropboxForm:{
                files:null,
                password:'',
            },
            hospitalSelected:false,
            selectedPrompt:false,
            hospitalName:'',
            nameEnglish :'',
            hospitalLocation:'',
            locationEnglish:'',
            hospitalDialog:false,
            hospitalDataSending: false,
            emailRules: [
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
        }
    },
    metaInfo() {
        return { 
            title: "FHR",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
    async created(){
        let lang = localStorage.getItem('lang')
        if(navigator.language == 'en-US'){
            if(lang =='ch'){
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }else {
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }
        }
        else{
            if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        }
        // location.reload();
      try {
            const res = await axios.get('Hlists')
            let response = res.data;
            // console.log(response);
            this.hospitalRes =response
            if(this.lang == 'en'){
                this.hospitalLocations = response.map(a => a.locationEnglish);
            }
            else{
            this.hospitalLocations = response.map(a => a.location);
            }
            //getting value of location only (value before comma)
        } 
        catch (err) {
              console.log(err);
        }
    },
    beforeMount(){
        // window.location.reload()
    },
    methods:{
    clearForm(){
        this.dropboxForm.files = null
        this.dropboxForm.password = ''
        this.qrCodeUrl= ''
        this.uploadAge=''
        this.uploadName=''
        this.uploadSex =''
        this.uploadSucess = false
        this.progress = 0
        this.hospitalName =''
        this.nameEnglish =''
        this.hospitalLocation =''
        this.hospitalLocName=''
        this.hospitalSelected = false
        this.hospitalDataSending = false
    },
    closeDialog(){
        this.clearForm();
        this.dialog = false;
    },
    async submit(){
        const config = {
                headers: {"content-type": "multipart/form-data"},
                onUploadProgress: (progressEvent) => {
                  var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                  this.progress = percentCompleted;
                  if(this.progress == 100)
                  {
                    this.compressing =true
                  }
                }
            };
        console.log(this.dropboxForm);
        let formData = new FormData();
        for (let i = 0; i < this.dropboxForm.files.length; i++) {  // 每个file append到formdata里
        formData.append('files', this.dropboxForm.files[i])
        }
        formData.append("password", this.dropboxForm.password)
        // formData.append("customerNo", this.dropboxForm.customerNo)
        try {
            this.whileUploading =true
            const res = await axios.post('UploadFile',formData, config)
            console.log('files uploaded!', res);
            if(this.hospitalSelected)
            {
            //send request to new api for data transfer if hospital is selected
            this.hospitalDataSending = true
            //axios req
            this.hospitalDataSending =false
            }
            this.uploadSucess = true,
            this.whileUploading =false,
            this.compressing =false,
            this.qrCodeUrl= res.data.qrcode;
            this.uploadSex = res.data.pT_SEX;
            // masking the name
            let altName = res.data.pT_NAME;
            if (altName.match(/^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/)) {
            //....English
                altName = altName.replaceAll('^',' ');
                var regex =/\b(\w{2})\w+(\w)\b/g;
                this.uploadName = altName.replace(regex, '$1**$2')
            } else if (altName.match(/[\u3400-\u9FBF]/)) {
                //....Chinese
                let space = altName.split(" ").length - 1
                let first = altName.charAt(0);
                let last = altName.charAt(altName.length - 1);
                if(space == 0)
                this.uploadName = first+'***'+last
                if(space == 1)
                this.uploadName = first+'** **'+last
                if(space == 2)
                this.uploadName = first+'** ** **'+last
                if(space == 3)
                this.uploadName = first+'** ** ** **'+last
            } else {
                console.log("chinese char other");
                altName = altName.replaceAll('^',' ');
                this.uploadName = altName.replace(regex, '$1**$2')
            }
            // getting age from birthday
            this.uploadAge = this.calculateAge(res.data.pT_AGE)
            
            } 
        catch (err) {
              this.whileUploading =false
              if(err.response.status == '413')
              {
                alert("error")
                return;
              }
              if(err.response.status == undefined){
                alert("Server inactive")
                return;
              }
              console.log(err.response);
              alert("Image upload failed. Please try again.")
        }
        
    },
    calculateAge(birthday) { 
        let year = Number(birthday.substr(0, 4));
        var month = Number(birthday.substr(4, 2)) - 1;
        var day = Number(birthday.substr(6, 2));
        var today = new Date();
        var age = today.getFullYear() - year;
        if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        age--;
        }
        return age
    }
    },
    components:{
        ImgContactForm,
        ImgHeader,
        ImgFooter,
    }
}
</script>
<style scoped>
#app{
    overflow-x: hidden;
}
.mt-20{
    margin-top: 20px;
}
.s_img_edit{
    position: absolute;
    margin-left: 32%;
}
.d_app_edit{
    position: absolute;
    margin-left: 38%;
}
ul {
  list-style: none;
}

ul li::before {
  content: "\2022";
  color: #5BD8FF;
  font-weight: bold;
  display: inline-block; 
  width: 1em;
  margin-left: -1em;
}
.cursor{
    cursor: pointer;
}
.phone{
    display: none;
    text-align: center;
}
.middle{
    padding-left: 167px;
}
.h-673{
    /* height: 673px; */
    max-width: 1080px;
    margin: auto;
}
.centered {
    margin-top: -100em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v-card__text{
  text-align: center;
}
canvas{
  height: 280px;
  width: 280px;
}
.d_con{
    font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 21px;
color: #00BEFF;
text-align: center;
}
.d_content{
    margin-left: 16px;
    margin-right: 16px;
    padding-top: 46px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    color: #707070; 
}
.d_content span{
    color: #012E81;
}
.d_app{
    width: 301px;
    height: 306px;
    margin-top: 25px;
    background: #F5FBFF;
    border-radius: 5px;
    text-align: center;
}
.d_icon{
    margin-top: 38px;
    margin-bottom: 16px;
    height: 78px;
    width: 78px;
}
.anime{
    position: absolute;
    margin-left: 37%;
    margin-top: -20px;
}
.p-scan{
    position: absolute;
    padding-left: 224px;
    padding-top: 64px;
    font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
color: #012E81;
}
.s_img{
    width: 375px;
    /* height: 216px; */
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    margin-top: 20px;
}
.f_img{
    width: 315px;
height: 175px;
    border-radius: 5px;
    margin-top: 44px;
    margin-left: 32px;
}
.mb-182{
    margin-bottom: 162px;
}
.inline{
    display: inline;
}
.circle {
    border-radius: 100%;
    height: 40px;
    width: 40px;
    text-align: center;
    margin-left: -20px;
    background: #00BEFF;
}
.mb-77{
    margin-bottom: 77px;
}
.mx-235{
    margin:auto;
    width: min-content;
}
.circle p {
	padding-top: 9px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    color: #FFFFFF;
}
.ma-0{
    margin:0px;
    padding:0px;
}
.hero_section{
    height: 762px;
    /* width: 100%; */
    color: #DEF2FE;
    background: rgba(222, 242, 254, 0.3);
    text-align: center;
      /* background: url("../assets/home.png") no-repeat left  !important; */
}
.hero_content{
    margin-top: -28em;
    position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
width: 965px;
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 64px;
/* line-height: 75px; */
text-align: center;
color: #00BEFF;
}
.f_left{
    float: left;
}
.hero_img1{
    float:left;
    min-width: 1165px;
    height: 762px;
}
.blue_button{
    cursor: pointer;
width: 387px;
height: 58px;
background: #012E81;
border-radius: 5px;
margin-bottom: 12px;
}
.blue_button_content{
    padding-top: 12px;
    font-size: 24px;
    font-style: normal;
    font-family: Roboto;
    font-weight: normal;
    color: #FFFFFF;}
.blue_button2{
    cursor: pointer;
    /* position: absolute; */
    width: 387px;
    height: 58px;
    border: 1px solid #012E81;
    box-sizing: border-box;
    border-radius: 5px;
    text-align: center;
}
.blue_button_content2{
    margin-top: 12px;
    font-size: 24px;
    font-style: normal;
    font-family: Roboto;
    font-weight: normal;
    color: #012E81;
    }
.h_title{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    color: #012E81;    
    margin-top: 153px;
    width: 454px;
    /* margin-left: 167px; */
    }
.s_title{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    width: 373px;
    margin-bottom: 20px;
    color: #707070;
    }
.ml-167{
    margin-left: 167px;
}
.h_img{
width: 465px;
/* height: 216px; */
}
.mt-132{
    margin-top: 132px;
}
.mt-24{
    margin-top: 24px;
}
.mt-49{
    margin-top: 49px;
}
.m_div{
    /* height: 726px; */
    background: #F5FBFF;
    text-align: center;
}
.pt-159{
    padding-top: 159px;
}
.blu{
    color: #00BEFF;
}
.blu span{
    color: #012E81;
}
.m_font{
    font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 36px;
line-height: 42px;
}
.how_img{
    background: black;
    width: 360px;
    height: 240px;
    border: 2px black;
}
.float-r{
    float: right;
}
.float-l{
    float: left;
}
.how_text{
    width: 350px;
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #012E81;
    margin-top: 24px;
}
.how_text2{
    width: 340px;
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    color: #707070;
}
.h-1595{
    height: 1495px;
}
.ml-50{
    margin-left: 170px;
}
.f_title{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    color: #012E81;
    text-align: center;
    padding-top: 100px;
    padding-bottom: 80px;
}
.f_title span{
    color: #00BEFF;
}
.column {
  float: left;
  width: 50%;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
.vl {
  height: 888px;
  border-left: 3px solid #DAE9F1;
}
.upload_div{
    cursor: pointer !important;
    padding-top: 40px;
    margin-top: 36px;
    margin-bottom: 95px;
    text-align: center;
    width: 908px;
    height: 112px;
    background: #F8F8F8;
    border-radius: 5px;
    margin-left: 36px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: #012E81;
    z-index: 1;
}
.f_step{
    font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 23px;
padding-left: 32px;
color: #00BEFF;
margin-top: -30px;
}
.f_content{
    font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
padding-left: 32px;
color: #707070;
width: 451px;
}
.mt-56{
    margin-top: 56px;
}
@media screen and (max-width: 2000px){.ml-50{margin-left: 145px;}}
@media screen and (max-width: 1950px){.ml-50{margin-left: 140px;}}
@media screen and (max-width: 1900px){.ml-50{margin-left: 120px;}}
@media screen and (max-width: 1750px){.ml-50{margin-left: 100px}}
@media screen and (max-width: 1650px){.ml-50{margin-left: 80px}}
@media screen and (max-width: 1530px){.ml-50{margin-left: 60px}}
@media screen and (max-width: 1530px){.ml-50{margin-left: 50px}}
@media screen and (max-width: 1330px){.ml-50{margin-left: 20px} .s_img_edit{
    margin-left: 46%;
}
.d_app_edit{
    margin-left: 50%;
}
.anime{
    margin-left: 52%;
}}
@media screen and (max-width: 1080px){
    /* .h-673{
    height: 803px;
} */
.ml-50{
        margin-left:0px
    }
    .hero_img1{
    min-width: 965px;
    object-fit: cover;
}
.anime{
    margin-left: 65%;
}
.s_img_edit{
    margin-left: 50%;
}
.d_app_edit{
    margin-left: 58%;
}
}
@media screen and (max-width: 960px){
    .hero_content{
    margin-top: -52em;
    width: 750px;
    font-size: 42px;
}
    .centered{
        margin-top: -126em;
    }
    .mt-49{
        max-width: 590px;
    margin: auto;
    }
    .h-1595{
    height: 1395px;
}
    .w-390{
        max-width: 520px;
        margin: auto;
    }
    .anime{
    display: none;
}
.s_img_edit{
    display: none;
}
.d_app_edit{
    display: none;
}
    .hero_img1{
    min-width: 765px;
    }
.middle{
    text-align: center;
    padding-left: 97px;
}
.h_title{
    margin-top: 53px;
}
.mt-132{
    margin-top: 0px;
}
.pt-159{
    padding-top: 59px;
    padding-left: 20px;
    padding-right: 20px;
}
.f_title{
    padding-top: 50px;
    padding-bottom: 20px;
}
/* .mx-235 {
    margin-left: 35px;
    margin-right: 10px;
} */
.f_content {
    width: fit-content;
}
.upload_div{
    width: 508px;
}
.float-l{
    float: none;
}
.anime{
    margin-left: 0px;
}
.s_img {
    width: 305px;
    height: 186px;}
.float-r{
    float: none;
}
/* .m_div {
    height: 1500px;} */
.h_img {
    width: -webkit-fill-available;
    /* height: 216px; */
}
.how_img {
    width: 360px;}
.courier_step{
    text-align: center;
    max-width: 380px;
    margin:auto;
}
/* .how_text{
    margin-left: 50px;
}
.how_text2{
    margin-left: 50px;
} */
.ml-50{
    margin-left: 0px;
}
}
@media screen and (max-width: 780px){
    .hero_img1{
    min-width: 665px;
    object-position: left;
    }
    .hero_content{
        margin-top: -53em;
    width: 480px;
}
.centered{
    margin-top: -128em;
}
}
@media screen and (max-width: 600px){
    .hero_img1{
    min-width: 565px;
    }
    .column {
    width: 100%;
  }
    .s_img_edit{
        display: none;
    }
    .middle{
        padding-left: 27px;
    }
    .upload_div{
        width: 408px;
    }
}
@media screen and (max-width: 460px){
    .w-390{
        max-width: 320px;
        margin: auto;
    }
    .hero_img1{
    min-width: 405px;
    }
    /* .how_text{
        margin-left: 10px;
    } */
    .how_text2{
        margin-left: 10px;
    }
    .centered{
        margin-top: -146em;
    }
    .hero_content{
            font-weight: 700;
            font-size: 28px;
            line-height: 33px;
            text-align: center;
            color: #FFFFFF;
            text-shadow: 4px 4px 8px rgb(0 0 0 / 25%);
            width: 300px;
            margin-top: -88em;
    }
    .blue_button{
        width: 230px;
        background: #00BEFF;
    }
    .blue_button2{
        width: 230px;
        border: 1px solid #00BEFF;
    }
    .blue_button_content2 {
    color: #00BEFF;
}
.h_title{
    font-size: 24px;
    line-height: 28px;
/* text-align: center; */
width: 294px;
}
.s_title{
    width: 300px;
}
.m_font {
    font-size: 24px;
    line-height: 28px;
}
/* .h-673 {
    height: 760px;
} */
.pt-159{
    padding-top: 29px;
}
/* .m_div{
    height: 1410px;
} */
.f_title{
    font-size: 24px;
line-height: 28px;
padding-left: 32px;
}
.upload_div{
    width: 319px;
    margin-bottom: 16px;
}
.mx-235{
    display: none;
}
.phone{
    display: block;
}
.s_img{
    width: -webkit-fill-available;
    height: auto;
    box-shadow: none;
    border-radius: 0px;
    margin-top: 0px;
    margin-bottom: 16px;
}
.circle{
    margin-left: 0px;
    margin: auto;
}
.f_step{
    margin-top: 16px;
    padding-left: 10px;
}
.f_content{
        padding-left: 37px;
    padding-right: 37px;
}
.mb-77{
    margin-bottom: 44px;
}
.anime{
    margin-top: 0px;
    margin-left: 32px;
    margin-bottom: 50px;
}
.h-1595{
    height: auto;
}
.f_img{
    border-radius: 0px;
    margin-left: 0px;
    width: 100%;
    margin-bottom: 26px;
}
.d_app{
    margin:auto;
    margin-bottom: 30px;
}
.mb-56{
    margin-bottom: 56px;
}
}
</style>

